import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { useGlobalAssetContext } from '../../../../../contexts';
import { useDirectTreasurySellAssetController } from '../../../../../hooks/products/DirectTreasurySell';
import { LateralBar } from '../../../components/LateralBar';
import { ListLoadingItemMobile } from '../ListLoadingItem/mobile';

import { DirectTreasuryListItemTypes } from '.';

export const DirectTreasuryListItemMobile: React.FC<DirectTreasuryListItemTypes.Props> = ({
  offer,
}) => {
  const id = offer.titleId;
  const { amountItem, amountValue, amountValueFormatted, handleChangeAmountItem } =
    useDirectTreasurySellAssetController(offer);
  const { infoGetter, selectedTab } = useGlobalAssetContext();

  const completeOffer = { ...offer, orderQuantity: amountItem || 0, orderValue: amountValue };

  const { Button, isSelected, forceLoading } = infoGetter(
    'directTreasurySell',
    completeOffer,
    'titleId'
  );

  const middleInfos1 = [
    {
      label: 'Quantidade disponível',
      value: <UI.Text color="neutral.dark">{offer.quantityAvailableFormatted}</UI.Text>,
    },
    {
      label: 'Valor total',
      value: <UI.Text color="neutral.dark">{offer.totalValueNormalized}</UI.Text>,
    },
  ];

  const middleInfos2 = [
    {
      label: 'Valor estimado',
      value: <UI.Text color="neutral.dark">{amountValueFormatted}</UI.Text>,
    },
    {
      label: 'Disponível em conta',
      value: <UI.Text color="neutral.dark">{offer.availableInAccountNormalized}</UI.Text>,
    },
  ];

  if (forceLoading) {
    return <ListLoadingItemMobile />;
  }

  return (
    <TableContent
      direction="row"
      space={0}
      p={0}
      px={Spacing['inline.xxxs']}
      isHighlighted={isSelected}>
      <LateralBar
        backgroundColor={selectedTab.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <VStack padding={Spacing['inset.sm']} space={Spacing['stack.xxxs']} w="full">
        <HStack justifyContent="space-between" alignItems="center">
          <UI.Text variant="semibold" color="neutral.black" fontSize={Typography['fontsize.lg']}>
            {offer.productNameNormalized}
          </UI.Text>
        </HStack>
        <HStack justifyContent="space-between">
          {middleInfos1.map(({ label, value }) => (
            <VStack space={Spacing['stack.quarck']} key={label} w="50%">
              <UI.Text color="neutral.black" variant="semibold">
                {label}
              </UI.Text>
              {value}
            </VStack>
          ))}
        </HStack>
        <HStack justifyContent="space-between">
          {middleInfos2.map(({ label, value }) => (
            <VStack space={Spacing['stack.quarck']} key={label} w="50%">
              <UI.Text color="neutral.black" variant="semibold">
                {label}
              </UI.Text>
              {value}
            </VStack>
          ))}
        </HStack>
        <HStack space={Spacing['inline.xxxs']} justifyContent="space-between" w="full">
          <VStack space={Spacing['stack.quarck']} flexGrow={1}>
            <UI.Text color="neutral.black" variant="semibold">
              Quantidade
            </UI.Text>
            <UI.InputStepper
              stepperValue={0.01}
              max={offer.availableQuantity}
              min={offer.minimumStepQuantity || 0}
              name={`treasury-amount-order-input-${id}`}
              keyboardType="numeric"
              fontSize={Typography['fontsize.md']}
              defaultValue={amountItem || 0}
              onChange={handleChangeAmountItem}
              showErrorMessage={false}
            />
          </VStack>
          <Stack alignSelf="flex-end">
            <Button
              id={selectedTab.typeGetterId}
              offer={completeOffer}
              productContextConstant={selectedTab}
            />
          </Stack>
        </HStack>
      </VStack>
    </TableContent>
  );
};
